/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * categorizes a product for MyDb
 * @export
 */
export const MyDbProductCategory = {
    MonthlySubscription: 'MONTHLY_SUBSCRIPTION',
    YearlySubscription: 'YEARLY_SUBSCRIPTION',
    SpecialOffer: 'SPECIAL_OFFER',
    Template: 'TEMPLATE',
    Support: 'SUPPORT'
} as const;
export type MyDbProductCategory = typeof MyDbProductCategory[keyof typeof MyDbProductCategory];


export function MyDbProductCategoryFromJSON(json: any): MyDbProductCategory {
    return MyDbProductCategoryFromJSONTyped(json, false);
}

export function MyDbProductCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDbProductCategory {
    return json as MyDbProductCategory;
}

export function MyDbProductCategoryToJSON(value?: MyDbProductCategory | null): any {
    return value as any;
}

